<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import { setColorTheme } from 'dashboard/helper/themeHelper';

const { t } = useI18n();

const isDark = ref(document.body.classList.contains('dark'));
let observer = null;

const syncFromBody = () => {
  const dark = document.body.classList.contains('dark');
  isDark.value = dark;
  document.documentElement.classList.toggle('dark', dark);
};

const toggleTheme = () => {
  const dark = !isDark.value;
  LocalStorage.set(LOCAL_STORAGE_KEYS.COLOR_SCHEME, dark ? 'dark' : 'light');
  setColorTheme(dark);
  syncFromBody();
};

const label = computed(() =>
  isDark.value
    ? t('SARRDEH.THEME.SWITCH_TO_LIGHT')
    : t('SARRDEH.THEME.SWITCH_TO_DARK')
);

onMounted(() => {
  syncFromBody();
  // The command bar can also change the theme; keep the icon in step.
  observer = new MutationObserver(syncFromBody);
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
  });
});

onBeforeUnmount(() => {
  if (observer) observer.disconnect();
});
</script>

<template>
  <button
    v-tooltip.bottom="label"
    type="button"
    class="sd-theme-toggle"
    :aria-label="label"
    :aria-pressed="isDark"
    @click="toggleTheme"
  >
    <span
      class="size-4"
      :class="isDark ? 'i-lucide-moon' : 'i-lucide-sun'"
      aria-hidden="true"
    />
  </button>
</template>
